class PerfectCoffeeJourney extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.keenSliderInstance = null;
    this.mobileMediaQuery = window.matchMedia('(max-width: 992px)');
    this.gridElement = null;
    
    // Bind methods
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.gridElement = this.querySelector('.perfect-coffee-journey__grid');
    
    if (!this.gridElement) return;

    // Initialize slider on mobile
    this.handleResize();
    this.mobileMediaQuery.addEventListener('change', this.handleResize);
  }

  disconnectedCallback() {
    // Clean up media query listener
    this.mobileMediaQuery.removeEventListener('change', this.handleResize);
    
    // Destroy slider if it exists
    this.destroyKeenSlider();
  }

  handleResize() {
    if (this.mobileMediaQuery.matches) {
      this.initKeenSlider();
    } else {
      this.destroyKeenSlider();
    }
  }

  initKeenSlider() {
    // Don't initialize if slider already exists or KeenSlider not available
    if (this.keenSliderInstance || !this.gridElement || !window.KeenSlider) return;

    // Add keen-slider classes
    this.gridElement.classList.add('keen-slider');
    this.gridElement.querySelectorAll('.perfect-coffee-journey__step').forEach(step => {
      step.classList.add('keen-slider__slide');
    });

    // Initialize Keen Slider
    this.keenSliderInstance = new KeenSlider(this.gridElement, {
      loop: false,
      slides: {
        perView: 1.5,
        spacing: 16,
      }
    });
  }

  destroyKeenSlider() {
    if (!this.keenSliderInstance || !this.gridElement) return;

    // Destroy slider instance
    this.keenSliderInstance.destroy();
    this.keenSliderInstance = null;

    // Remove keen-slider classes
    this.gridElement.classList.remove('keen-slider');
    this.gridElement.querySelectorAll('.keen-slider__slide').forEach(step => {
      step.classList.remove('keen-slider__slide');
    });
  }
}

if (!customElements.get('perfect-coffee-journey')) {
  customElements.define('perfect-coffee-journey', PerfectCoffeeJourney);
}

